import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config.service';

import { LocalStorageManager } from '../helper/local-storage-manager.helper';

@Injectable()
export class AuthGuard {
  constructor(private router: Router, private fuseConfig: FuseConfigService) {}

  canActivate(): boolean {
    const userIdLS = LocalStorageManager.regData;

    if (this.authorized()) {
      return true;
    } else {
      this.router.navigate(['/client/auth/login'], { queryParams: userIdLS ? { user: userIdLS } : null });

      this.fuseConfig.setConfig({
        layout: {
          navigation: 'none',
          toolbar: 'none',
          footer: 'none',
        },
      });
    }

    return false;
  }

  authorized(): boolean {
    const LSC = LocalStorageManager.client;

    if (LSC) {
      return LSC.token.refresh !== '';
    }

    return false;
  }
}
